// removed by extract-text-webpack-plugin
module.exports = {"component":"_1aNKg7TeUeS9FXTlJym0YA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Widget/Header/Logo/logo.css
// module id = 1255
// module chunks = 2